import styled from '@emotion/styled';

const ColorBlock = styled.div`
  position: relative;
  width: 20px;
  height: 20px;
  border-radius: 10%;
  background-color: ${(props) => props.color};
`;

const ColorContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export { ColorBlock, ColorContainer };
